import {makeStyles, Theme} from '@material-ui/core/styles'
import {Colors} from 'components/common/useBaseStyle'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    '& > .MuiDialog-container > .MuiPaper-root': {
      minWidth: 530,
    },
  },
  contentWrap: {
    padding: '20px 45px',
    minHeight: 368,
  },
  table: {
    position: 'relative',
    minWidth: 880,
    color: 'red',
    marginTop: '15px',
    '& td': {
      color: Colors.text.content,
      fontSize: '0.8125rem',
      lineHeight: 2,
      paddingTop: 6,
      paddingBottom: 6,
      height: 43,
    },
    marginBottom: 20,
  },
  tableHeader: {
    height: 42,
    backgroundColor: Colors.tableHeaderBackground,
    verticalAlign: 'middle',
    borderRadius: 10,
    '& th': {
      color: Colors.text.content,
      fontSize: '0.8125rem',
      lineHeight: '1rem',
      fontWeight: 'bold',
    },
  },
  productTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
    textAlign: 'center',
  },
  productWrapper: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    gap: 10,
    marginTop: 20,
    marginBottom: 20,
    background: '#fee2e2',
    border: '1px solid #fca5a1',
    padding: 10,
  },
  reasonInput: {
    height: 30,
    border: '1px solid #ccc',
    paddingLeft: 10,
    width: '80%',
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 20,
  },
}))

export default useStyles
